import { InjectionToken } from '@angular/core';
import type { ICommonModuleConfig } from './ICommonModuleConfig';

/**
 * @public
 */
export const COMMON_MODULE_CONFIG = new InjectionToken<ICommonModuleConfig>('Common Module Configuration');
